import styled from "styled-components";

export const CardContainer = styled.div`
  .blockoff-wrapper {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 300px;
    gap: 16px;
    overflow-x: auto;
    white-space: nowrap;
    width: 100%;
  }
  .event-item {
    width: 100%;
    border-radius: 20px;
    padding: 16px;
    background-color: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .event-details {
      display: flex;
      flex-direction: column;
      row-gap: 8px;
    }
    .event-icons {
      display: flex;
      align-items: center;
      svg {
        cursor: pointer;
      }
    }
  }
  .MuiTabs-root {
    margin-bottom: 0px;
  }
  .text-wrapper{
    font-weight: 800 !important;
  }
`;
